import { httpService } from "./httpService";

export const requestFeatureService = {
    requestFeature(featureName: string, formData: FormData) {
        return httpService.postFormDataRequest(`feature-requests/${featureName}`, formData);
    },
    
    requestFeatureOpen(featureName: string, formData: FormData) {
        return httpService.postFormDataRequest(`open/feature-requests/${featureName}`, formData);
    },
}